module.exports = __webpack_public_path__ + "img/RPX.6c27fbaa.svg";